import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.seek.com',
    clientDomain: 'talent.seek.co.nz',
    clientId: 'GsU5uidhWIV38OB44a9Nn6nXPmEebuNA',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://talent.seek.co.nz/contactus/',
    },
    siteName: siteNames.employer.seek.nz,
    zone: getZoneFromSite(siteNames.employer.seek.nz),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=talent_seek_co_nz.js.map